import { loadView } from '@/router'

export default [
  {
    path: 'users',
    name: 'manage-users',
    component: loadView('Application/Manage/Users'),
    redirect: {
      name: 'manage-users-list'
    },
    showInAlfred: true,
    alfredTitle: 'Manage - Users',
    children: [
      {
        path: 'list',
        name: 'manage-users-list',
        component: loadView('Application/Manage/Users/List')
      },
      {
        path: ':userId',
        name: 'manage-users-user',
        component: loadView('Application/Manage/Users/Profile'),
        props: true,
        redirect: {
          name: 'manage-users-user-profile'
        },
        children: [
          {
            path: 'profile',
            name: 'manage-users-user-profile',
            component: loadView('Application/Manage/Users/Profile/View')
          }
        ]
      }
    ]
  }
]
